class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));

    const closeButton = this.querySelector('button[type="button"]');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    // Check if this is the header search (inline overlay mode)
    this._isHeaderSearch = this.classList.contains('header__search');

    if (this._isHeaderSearch) {
      const header = document.querySelector('.site-header');
      if (header) {
        header.classList.add('search-is-open');
      }

      // Position search overlay on top of the center nav pill
      this._positionOverNav();

      // Re-measure on resize so it stays aligned
      this._onResizeEvent = this._onResizeEvent || (() => this._positionOverNav());
      window.addEventListener('resize', this._onResizeEvent);
    } else {
      document.body.classList.add('overflow-hidden');
      const header = document.querySelector('.site-header');
      if (header) {
        const headerTop = header.getBoundingClientRect().top + window.scrollY;
        document.documentElement.style.setProperty('--header-top', headerTop + 'px');
      }
    }

    // Focus the search input
    const searchInput = this.detailsContainer.querySelector('input[type="search"]');
    if (searchInput) {
      setTimeout(() => searchInput.focus(), 100);
    }
  }

  _positionOverNav() {
    const headerLayout = this.closest('.site-header')?.querySelector('.header-layout');
    if (!headerLayout) return;

    const navPill = headerLayout.querySelector('.site-nav--clean');
    // On mobile the nav pill is hidden (small--hide), fall back to full header-layout
    const target = (navPill && navPill.offsetWidth > 0) ? navPill : headerLayout;

    const layoutRect = headerLayout.getBoundingClientRect();
    const targetRect = target.getBoundingClientRect();

    this.style.setProperty('--search-left', (targetRect.left - layoutRect.left) + 'px');
    this.style.setProperty('--search-top', (targetRect.top - layoutRect.top) + 'px');
    this.style.setProperty('--search-width', targetRect.width + 'px');
    this.style.setProperty('--search-height', targetRect.height + 'px');
  }

  close(focusToggle = true) {
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');

    const header = document.querySelector('.site-header');
    if (header) {
      header.classList.remove('search-is-open');
    }

    // Remove resize listener
    if (this._onResizeEvent) {
      window.removeEventListener('resize', this._onResizeEvent);
    }

    if (focusToggle && this.summaryToggle) {
      this.summaryToggle.focus();
    }
  }
}

customElements.define('details-modal', DetailsModal);
